(function($, once, Drupal) {
    Drupal.behaviors.text_input = {
      attach(context) {
        const textInput = once(
          'activate',
          '.js-text-input',
          context
        );
        const $textInput = $(textInput);
        if (textInput.length > 0) {
            $textInput.parent().on('click.activate', function (event) {
              if (event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'LABEL') {
                $(event.currentTarget).children('input').trigger('focus');
              }
            });
          }
        }
      };
    })(jQuery, once, Drupal);